import Card3Ship from "../Previews/Card3Ship/Preview";
import Destination3 from "../Previews/Destination/3/Preview";
import DealCards from "../Previews/Destination/4/Preview";
import ExperiencesCard from "../Previews/ExperiencesCard/Preview";
import ShipBannerPreview from "../Previews/Ship/Banner/Preview";
import MusicianCards from "../Previews/MusicianCards/Preview";

export const entertainmentpages = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 1,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
          required: false,
        },
      ],
      preview: (activetab, cardData) => (
        <ShipBannerPreview activetab={activetab} cardData={cardData} />
      ),
    },

    {
      type: 3,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

      ],
      level1: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English subtitle",
          key: "subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese subtitle",
          key: "simplified_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese subtitle",
          key: "traditional_chinese_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa subtitle",
          key: "bahasa_subtitle",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

      ],
      level2: [
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-6",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "Popup Image",
          key: "image2",
          className: "col-lg-6",
          placeholder: "Upload Popup Image",
          type: "file",
          withAlt: true,
          required: false,
        },
         {
          title: "Mobile Card Image",
          key: "mobile_image",
          className: "col-lg-6",
          placeholder: "Upload Mobile Card Image Width: 1024, height: 1150",
          type: "file",
          withAlt: true,
          required: false,
        },
         {
          title: "Mobile Popup Image",
          key: "mobile_image2",
          className: "col-lg-6",
          placeholder: "Upload Mobile Popup Image Width: 1024, height: 1150",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

        {
          title: "Popup English Description",
          key: "popup_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Simplified Chinese Description",
          key: "popup_simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Traditional Chinese Description",
          key: "popup_traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Bahasa Description",
          key: "popup_bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Date",
          key: "date",
          className: "col-lg-3",
          lang:"EN",
          type: "date-lang",

        },
        {
          title: "Simplified Chinese Date",
          key: "simplified_chinese_date",
          className: "col-lg-3",
          lang:"SC",
          type: "date-lang",

        },
        {
          title: "Traditional Chinese Date",
          key: "traditional_chinese_date",
          className: "col-lg-3",
          lang:"TC",
          type: "date-lang",

        },
        {
          title: "Bahasa Date",
          key: "bahasa_date",
          className: "col-lg-3",
          lang:"Bahasa",
          type: "date-lang",
        }
      ],
      preview: (activetab, cardData) => (
        <DealCards activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },


      ],
      level1: [
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-6",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },
         {
          title: "Popup Image",
          key: "image2",
          className: "col-lg-6",
          placeholder: "Upload Popup Image",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Popup English Title",
          key: "popup_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Popup Simplified Chinese Title",
          key: "popup_simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Popup Traditional Chinese Title",
          key: "popup_traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Popup Bahasa Title",
          key: "popup_bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "Popup English Description",
          key: "popup_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Simplified Chinese Description",
          key: "popup_simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Traditional Chinese Description",
          key: "popup_traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Bahasa Description",
          key: "popup_bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
       
        {
          title: "Ship",
          key: "ship",
          className: "col-lg-4",
          type: "select",
          menuOption:(item)=> {
            return item.component[1].dataArray.map(item=>({id:item.title,name:item.title}))},
          option: [
            {
              id: "genting_dream",
              name: "GENTING DREAM",
            },
            {
              id: "resort_world_one",
              name: "Star Navigator",
            },
          ],
          required: false,
        },
      ],
      groupBy: "ship",
      preview: (activetab, cardData) => (
        <ExperiencesCard activetab={activetab} cardData={cardData} />
      ),
    },
     {
      type: 2,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },


      ],
      level1: [
       {
          title: "Card Image",
          key: "image",
          className: "col-lg-6",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "Popup Image",
          key: "image2",
          className: "col-lg-6",
          placeholder: "Upload Popup Image",
          type: "file",
          withAlt: true,
          required: false,
        },
         {
          title: "Mobile Card Image",
          key: "mobile_image",
          className: "col-lg-6",
          placeholder: "Upload Mobile Card Image Width: 1024, height: 1150",
          type: "file",
          withAlt: true,
          required: false,
        },
         {
          title: "Mobile Popup Image",
          key: "mobile_image2",
          className: "col-lg-6",
          placeholder: "Upload Mobile Popup Image Width: 1024, height: 1150",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

        {
          title: "Popup English Description",
          key: "popup_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Simplified Chinese Description",
          key: "popup_simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Traditional Chinese Description",
          key: "popup_traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Popup Bahasa Description",
          key: "popup_bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Date",
          key: "date",
          className: "col-lg-3",
          lang:"EN",
          type: "date-lang",

        },
        {
          title: "Simplified Chinese Date",
          key: "simplified_chinese_date",
          className: "col-lg-3",
          lang:"SC",
          type: "date-lang",

        },
        {
          title: "Traditional Chinese Date",
          key: "traditional_chinese_date",
          className: "col-lg-3",
          lang:"TC",
          type: "date-lang",

        },
        {
          title: "Bahasa Date",
          key: "bahasa_date",
          className: "col-lg-3",
          lang:"Bahasa",
          type: "date-lang",
        },
        {
          title: "Ship",
          key: "ship",
          className: "col-lg-4",
          type: "select",
          menuOption:(item)=> {
            return item.component[1].dataArray.map(item=>({id:item.title,name:item.title}))},
          option: [
            {
              id: "genting_dream",
              name: "GENTING DREAM",
            },
            {
              id: "resort_world_one",
              name: "Star Navigator",
            },
          ],
          required: false,
        },
      ],
      groupBy: "ship",
       preview: (activetab, cardData) => (
         <MusicianCards activetab={activetab} cardData={cardData} />
       ),
    },
  ],
};
